<inline-skjema>
  <form [formGroup]="skjema" (ngSubmit)="lagre()">
    <inline-skjema-tittel>{{ 'Rediger referat'|translate }}</inline-skjema-tittel>
    <moeteprotokoll-rediger-saksreferat [skjema]="skjema" [gruppeId]="gruppeId()" [avstemningsstatus]="avstemningsstatus()" [eksponerVisSaksbeskrivelseKnapp]="false"/>
    <inline-skjema-handlinger navigasjonforhindret-flash>
      <submit-button [skjema]="skjema" [arbeidPaagaar]="lagrer()" [spinnerTekst]="'Lagrer...'|translate">
        {{ 'Lagre'|translate }}
      </submit-button>
      <button mat-stroked-button type="button" (click)="avbryt()">
        {{ 'Avbryt'|translate }}
      </button>
      <button mat-button color="primary" [matMenuTriggerFor]="limInnMeny" type="button">{{ 'Lim inn...'|translate }}</button>
      <mat-menu #limInnMeny="matMenu" class="lim-inn-meny">
        <button mat-menu-item type="button" (click)="limInnSaksbeskrivelse()">
          <div>{{ 'Lim inn saksbeskrivelse'|translate }}</div>
          <div class="sublinje">{{ 'Saksbeskrivelse kopieres inn som referattekst'|translate }}</div>
        </button>
        <button mat-menu-item type="button" (click)="limInnAlleBeslutningsforslag()">
          <div>{{ 'Lim inn alle beslutningsforslag'|translate }}</div>
          <div class="sublinje">
            @if (antallBeslutningsforslag() > 0) {
              {{ 'Endrer {antall} beslutningsforslag til beslutninger'|translate : {antall: antallBeslutningsforslag()} }}
            } @else {
              {{ 'Saken inneholder ingen beslutningsforslag'|translate }}
            }
          </div>
        </button>
      </mat-menu>
      @if (antallFeil() > 0) {
        <div class="feil" (click)="gaaTilFoersteFeil()">{{ 'Skjemaet inneholder {antall} feil, gå til første'|translate :{antall: antallFeil()} }}</div>
      }
    </inline-skjema-handlinger>
  </form>
</inline-skjema>
